import React from "react";
import { HashRouter, Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import PagePath from "./util/RoutePagePath";
import ProductDetail from "./components/Productdetail";
import About from "./components/About";
import Return from "./components/Return";
import Terms from "./components/Terms";
import Cart from "./components/Cart";
import Checkout from "./components/Checkout";
import Success from "./components/Success";
import Subscription from "./components/Subscribe";
import Privacy from "./components/Privacy";
import JoinUs from "./components/JoinUs";
import Guide from "./components/Guide";
import Shipping from "./components/Shipping";
import ContactUs from "./components/ContactUs";
import Cookies from "./components/Cookies";

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route
          path={`${PagePath.PRODUCTDETAIL_PAGE}/:id`}
          element={<ProductDetail />}
        />
        <Route path={PagePath.COOKIE_PAGE} element={<Cookies />} />
        <Route path={PagePath.CONTACT_PAGE} element={<ContactUs />} />
        <Route path={PagePath.SHIPPING_PAGE} element={<Shipping />} />
        <Route path={PagePath.GUIDE_PAGE} element={<Guide />} />
        <Route path={PagePath.JOIN_PAGE} element={<JoinUs />} />
        <Route path={PagePath.PRIVACY_PAGE} element={<Privacy />} />
        <Route path={PagePath.SUBSCRIPTION_PAGE} element={<Subscription />} />
        <Route path={PagePath.SUCCESS_PAGE} element={<Success />} />
        <Route path={PagePath.CHECKOUT_PAGE} element={<Checkout />} />
        <Route path={PagePath.CART_PAGE} element={<Cart />} />
        <Route path={PagePath.TERMS_PAGE} element={<Terms />} />
        <Route path={PagePath.RETURN_PAGE} element={<Return />} />
        <Route path={PagePath.ABOUT_PAGE} element={<About />} />
        <Route path={PagePath.HOME_PAGE} element={<Home />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
